import React from 'react'
import { RichTextDisplay } from '@ztechapps/webui.input'
import { Container } from 'react-bootstrap'

export const BlogContent = ({ contentHtml }) => {
  return (
    <div className="py-4">
      <Container>
        {/* trustedSource: blog copy is authored in the admin app by staff, not attacker-reachable */}
        <RichTextDisplay contentHtml={contentHtml} trustedSource />
      </Container>
    </div>
  )
}
